import { Logger } from "@core/helpers/logger.helpers";
import { posthog } from "posthog-js";
import { AuthenticationManager } from "@core/managers/authentication.manager";
import { UserStorageManager } from "@core/managers/user-storage.manager";
import { EtabProfileService } from "@core/services";

export class PosthogManager {
  static async init() {
    try {
      const apiKey = process.env.VUE_APP_POSTHOG_API_KEY;
      const apiHost = process.env.VUE_APP_POSTHOG_API_HOST;

      posthog.init(apiKey, {
        api_host: apiHost,
        capture_pageview: false,
        autocapture: false,
      });
    } catch (error) {
      Logger.info(`[Posthog::Manager] ${error}`);
    }
  }
  static async setUserIdentify() {
    try {
      const isAuthenticated = await AuthenticationManager.isUserAuthenticated();

      if (!isAuthenticated) {
        return;
      }

      // Define profile info of the user
      //
      const user = await UserStorageManager.getUser();
      const etab = await EtabProfileService.get();

      posthog.identify(user.email, {
        email: user.email,
        name: user.nom,
        etab_segment: etab.segment,
        etab_name: etab.nom_etablissement,
        zip_code: etab.code_postal_raison_sociale ?? etab.code_postal,
        is_logged_in: isAuthenticated,
      });
    } catch (error) {
      Logger.info(`[Posthog::Manager] ${error}`);
    }
  }
  static async captureEvent(eventName, eventProperties) {
    try {
      posthog.capture(eventName, eventProperties);
    } catch (error) {
      Logger.info(`[Posthog::Manager] ${error}`);
    }
  }
}
